::ng-deep particle-single-case-content{display:flex;width:100%}::ng-deep particle-single-case-content .pos-relative{height:initial}
/*# sourceMappingURL=single-case-content.component-X3TPBJHI.css.map */
